<template>
  <div class="OrderStatus-root car-wendu">
    <info-box title="温度信息">
      <template slot="mainContent">
        <a-descriptions-item>
          <div id="wrapper">
            <div v-show="noData" class="noData">暂无数据</div>
            <div v-show="!noData" id="main"></div>
          </div>
        </a-descriptions-item>
      </template>
      <div slot="titleContent">
        <span class="title">温度信息</span>
        <a-select :value="value" class="select-wrapper" @change="handleChange">
          <a-select-option
            v-for="(item, index) in waybillList"
            :key="index"
            :value="item.id"
          >
            运单{{index+1}}
          </a-select-option>
        </a-select>
      </div>
    </info-box>
  </div>
</template>

<script>
import moment from "moment";
import { pubLocGps } from "@/pages/orderManage/api.js";
import InfoBox from "./InfoBox.vue";
// 引入 ECharts 主模块
const echarts = require("echarts");
// // 引入柱状图
// require("echarts/lib/chart/line");

// // 引入提示框和标题组件
// require("echarts/lib/component/tooltip");
// require("echarts/lib/component/title");

export default {
  name: "OrderStatus",
  components: {
    InfoBox,
  },
  props: {
    waybillList: {
      type: Array,
      default: () => [],
    },
    startTime: {
      type: [String, Number],
      default: "",
    },
    vehicle: {
      type: String,
      default: "",
    },
    driverPhone: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      myChart: {},
      value: "",
      noData: false,
    };
  },
  computed: {
    endTime() {
      let endTime = "";
      if (this.waybillList.length > 0) {
        endTime = this.waybillList.filter((item) => item.id === this.value)[0]
          .signingTime;
      }
      return this.formatDate(endTime);
    },
  },
  watch: {
    waybillList: {
      handler(waybillList) {
        this.value = (waybillList[0] && waybillList[0].id) || "";
        setTimeout(() => {
          this.getTemperatureData();
        }, 1000);
      },
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.chartsInit();
    });
  },
  methods: {
    chartsInit() {
      this.myChart = echarts.init(document.getElementById("main"));
    },

    handleChange(value) {
      this.value = value;
      this.getTemperatureData();
    },
    formatDate(time) {
      if (!time) {
        return moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      }
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    async getTemperatureData() {
      if (!this.startTime) {
        this.noData = true;
        return;
      }
      const postData = {
        filter: {
          licensePlate: this.vehicle,
          phone: this.driverPhone || null,
          gpsStartTime: this.formatDate(this.startTime),
          gpsEndTime: this.endTime,
        },
        strategy: 'LICENSE_PLATE_FIRST'
      };
      const data = await pubLocGps(postData);
      if (data === "") {
        // this.$message.info("暂无温度信息");
        this.noData = true;
        return;
      }
      this.noData = false;
      // const { gpsPlaceVos } = data;
      const yTime = [];
      const xData1 = [];
      const xData2 = [];
      const xData3 = [];
      const xData4 = [];
      // gpsPlaceVos.map((item) => {
      //   yTime.push(item.gpsTime);
      //   xData1.push(item.temperature1);
      //   xData2.push(item.temperature2);
      //   xData3.push(item.temperature3);
      //   xData4.push(item.temperature4);
      //   return item;
      // });
      data.records.map(item => {
        const { temperatureInfo = [] } = item;
        if (temperatureInfo.length) {
          yTime.push(temperatureInfo[0]?.time || '');
          xData1.push(temperatureInfo[0]?.value);
          xData2.push(temperatureInfo[1]?.value);
          xData3.push(temperatureInfo[2]?.value);
          xData4.push(temperatureInfo[3]?.value);
        }
        return item;
      })

      this.options = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["1路温度", "2路温度", "3路温度", "4路温度"],
          left: "2%",
          top: "5%",
        },
        grid: {
          top: "20%",
          left: "2%",
          right: "2%",
          bottom: "5%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: yTime,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "1路温度",
            type: "line",
            stack: "温度",
            data: xData1,
          },
          {
            name: "2路温度",
            type: "line",
            stack: "温度",
            data: xData2,
          },
          {
            name: "3路温度",
            type: "line",
            stack: "温度",
            data: xData3,
          },
          {
            name: "4路温度",
            type: "line",
            stack: "温度",
            data: xData4,
          },
        ],
      };

      this.myChart.setOption(this.options);
    },
  },
};
</script>

<style scoped>
#wrapper {
  width: 100%;
  height: 400px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
#main {
  width: 100%;
  height: 100%;
}
.noData {
  text-align: center;
  font-size: 20px;
  padding-top: 100px;
  color: #ccc;
}
</style>
<style lang="less">
.car-wendu {
  .ant-descriptions-item > span {
    display: block;
  }
  .select-wrapper {
    width: 260px;
    float: right;
  }
}
</style>